<template>
  <div class="generic-search-container">
    <el-card class="search-card" shadow="never">
      <div class="search-header">
        <el-form :inline="true" :model="simpleForm" class="simple-search-form" size="small" @submit.native.prevent>
          <!-- Simple Search Field -->
          <el-form-item>
            <el-input
              v-model="simpleSearchValue"
              :placeholder="placeholder"
              prefix-icon="el-icon-search"
              clearable
              @keyup.enter.native="handleSearch"
              class="simple-input"
            />
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch" :loading="loading">
              Search
            </el-button>
            <el-button v-if="hasAdvanced" @click="toggleAdvanced" :type="isAdvanced ? 'info' : 'default'">
                {{ isAdvanced ? 'Simple' : 'Advanced' }}
                <i :class="isAdvanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">Reset</el-button>
          </el-form-item>
        </el-form>

        <!-- Right side actions slot -->
        <div class="search-actions">
          <slot name="actions"></slot>
        </div>
      </div>

      <!-- Advanced Search Area -->
      <transition name="el-zoom-in-top">
        <div v-if="isAdvanced && hasAdvanced" class="advanced-search-content">
          <el-divider class="search-divider"><i class="el-icon-set-up"></i> Advanced Filters</el-divider>
          <el-form :model="advancedForm" label-width="100px" size="small" class="advanced-form">
            <slot name="advanced" :form="advancedForm"></slot>
            <div class="advanced-footer">
               <el-button type="primary" size="small" icon="el-icon-check" @click="handleSearch">Apply Filters</el-button>
            </div>
          </el-form>
        </div>
      </transition>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "GenericSearchContainer",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Quick search...",
    },
    hasAdvanced: {
      type: Boolean,
      default: false,
    },
    // Initial values for advanced form if needed
    initialAdvanced: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      simpleSearchValue: "",
      isAdvanced: false,
      simpleForm: {}, // Just to keep el-form happy
      advancedForm: { ...this.initialAdvanced },
    };
  },
  methods: {
    toggleAdvanced() {
      this.isAdvanced = !this.isAdvanced;
    },
    handleSearch() {
      const searchData = {
        isAdvanced: this.isAdvanced,
        simple: this.simpleSearchValue,
        advanced: this.isAdvanced ? { ...this.advancedForm } : {},
      };
      this.$emit("search", searchData);
    },
    handleReset() {
      this.simpleSearchValue = "";
      this.advancedForm = { ...this.initialAdvanced };
      this.$emit("reset");
      if (this.isAdvanced) {
          this.handleSearch();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.generic-search-container {
  margin-bottom: 24px;
  
  .search-card {
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

    :deep(.el-card__body) {
      padding: 16px 20px;
    }
  }

  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
  }

  .simple-search-form {
    display: flex;
    align-items: center;
    
    .el-form-item {
      margin-bottom: 0;
      margin-right: 12px;
      
      &:last-child {
        margin-right: 0;
      }
    }

    .simple-input {
      :deep(.el-input__inner) {
        width: 280px;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .advanced-search-content {
    margin-top: 16px;
    padding-top: 5px;
  }

  .search-divider {
    margin: 15px 0 20px 0;
    :deep(.el-divider__text) {
        background: transparent;
        color: #909399;
        font-weight: 500;
        font-size: 13px;
        i { margin-right: 5px; }
    }
  }

  .advanced-form {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 10px 20px;
    
    :deep(.el-form-item) {
        margin-bottom: 15px;
    }
    
    :deep(.el-input__inner), :deep(.el-select .el-input__inner) {
        border-radius: 8px;
    }
  }
  
  .advanced-footer {
      grid-column: 1 / -1;
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
  }

  .search-actions {
    display: flex;
    gap: 10px;
  }
}


</style>
